import storePlugin from './store';
import GlobalLoader from './GlobalLoader';
import * as constants from './constants';

const log = require('debug')('@mycure/vue-plugins/' + constants.NAMESPACE);

/**
 * @typedef {Object} PluginOpts
 * @property {string} namespace
 * @property {import('vuex').Store} store vuex store
 * @property {import('./store/store').StoreOpts} storeOpts
 * @property {boolean} injectComponents
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {PluginOpts} [opts]
   */
  install (Vue, opts) {
    const { storeOpts, ...restOpts } = opts = Object.assign({ namespace: constants.NAMESPACE }, opts);
    log(`installing '${constants.NAMESPACE}' with opts'`, opts);

    // instal store module
    if (opts.store && opts.sdk) Vue.use(storePlugin, { ...restOpts, ...storeOpts });

    // inject components
    if (opts.injectComponents) Vue.component('mc-global-loader', GlobalLoader);
  },
  namespace: constants.NAMESPACE
};
